<template>
  <v-container class="home">
    <v-row>
      <v-col>
        <h2>Ukjent url</h2>
        <br />
        <p>
          Siden du prøvde å navigere til finnes ikke i VIGO Kodeverk. Vennligst kontakt support om
          du mener dette er en feil.
        </p>
        <br />
        <v-btn large color="secondary" outlined @click="router.push('/home')">
          {{ t('button.goToStarpage') }}
        </v-btn>
      </v-col>
      <v-col class="icon-col">
        <v-icon size="350" color="grey">
          mdi-alert-circle-outline
        </v-icon>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'

const router = useRouter()
const { t } = useI18n()
</script>

<style lang="sass" scoped>
.home
	margin: 2em 0em

@media only screen and (min-width: 940px)
	.home
		margin: 12em 10em 0 10em

.icon-col
	display: flex
	justify-content: center

.home-btn
	border: 2px solid #ffffff
	-webkit-border-radius: 7px
	-moz-border-radius: 7px
	border-radius: 7px
	padding: 20px 20px 15px 20px
	display: block
	height: 100%
	text-decoration: none
	text-align: center
	min-width: 250px
	width: 100%
</style>
